import React, { useState, useEffect, useRef } from "react";
import axios from "axios"
import { Container, Row, Col } from "react-bootstrap";
import { Divider, Form, FormInput } from "semantic-ui-react";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment/moment";
import DateRangePicker from 'rsuite/DateRangePicker';

const VoucherEdit = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const [aloc, setAloc] = useState('')
    const [tipe, setTipe] = useState('')
    //const [date, setDate] = useState([])
    const [date, setDate] = useState(null)
    const [name, setName] = useState('')
    const [desc, setDesc] = useState('')
    const [code, setCode] = useState('')
    const [value, setValue] = useState(0)
    const [percent, setPercent] = useState(0)
    const [trx, setTrx] = useState(0)
    const [idVoucher, setIdVoucher] = useState('')
    const [combine, setCombine] = useState('N')
    const [expose, setExpose] = useState('N')
    const [usageLimit, setUsageLimit] = useState('N')
    const [minQty, setMinQty] = useState(1)
    const formatDateTime = (date) => {
        if (!date) return "";
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };
        
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);

    const alocation = [
        { key: 'M', text: 'Member', value: 'M' },
        { key: 'C', text: 'Customer', value: 'C' },
    ]
    console.log(location)
    const type = [
        { key: 'D', text: 'Percent', value: 'D' },
        { key: 'N', text: 'Nominal', value: 'N' },
        { key: 'O', text: 'Ongkir', value: 'O' }
    ]
    
    const handleCheckCombine = (e) => {
        if (e.checked) {
            setCombine("Y");
            setCombineWith((prev) => prev || "ongkir");
        } else {
            setCombine("N");
            setCombineWith("");
        }
    };
    
    const handleUsageLimit = (e) => {
        if (e.checked) {
            setUsageLimit("Y");
            setUsageLimitValue(0);
        } else {
            setUsageLimit("N");
            setUsageLimitValue(0);
        }
    };

    const handleCheckExpose = (e) => {
        if (e.checked){
            setExpose('Y')
        }else{
            setExpose('N')
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();      

        setSubmitted(true);

        if (!aloc || !tipe || !desc) {
            return;
        }

        const final_combineWith = combine == "N" ? "N" : combineWith;

        const param = {
            id_voucher:idVoucher,
            alocation:aloc,
            tipe:tipe,
            date_range:date,
            name:name,
            description:desc,
            voucher_code:code,
            //voucher_value:value,
            //voucher_percent: percent,
            voucher_value: Number(value || 0),
            voucher_percent: Number(percent || 0),
            is_expose:expose,
            is_combine:combine,
            minimum_trx:trx,
            minimum_qty:minQty,
            combineWith:final_combineWith,
            limit_usage: Number(usageLimitValue || 0),
        }

        console.log(param)
        
        axios({
            method:"POST",
            url:`${global.SRV}api_hoops_cms/controler/voucher.php/?index=3`,
            headers:{'Content-Type': 'text/plain'},
            data:param
        })
        .then(res => { console.log(res.data)
            if (res.data.state === 200){
                navigate('/voucher')
            }
        })
    }

    useEffect(() => { 
        const data = location.state
        setName(data.name)
        setDesc(data.description)
        setAloc(data.customer_type)
        setTipe(data.type)
        /*
        setDate([
            new Date(data.start_date),
            new Date(data.end_date)
        ])
            */
        setPercent(data.percent)
        setCode(data.voucher_code)
        setValue(data.nominal)
        setTrx(data.minimum_trx)
        setIdVoucher(data.id_voucher)
        setMinQty(data.min_qty)
        

        setExpose(data.show)

        setCombine(data.is_combine)
        setCombineWith(
            data.is_combine === "Y" ? data.combine_with : ""
        );

        setUsageLimitValue(data.limit_usage)
        setUsageLimit(
            data.limit_usage > 0 ? "Y" : "N"
        );

        

    },[location.state])

    useEffect(() => {
        if (location.state?.start_date && location.state?.end_date) {
            setDate([
                new Date(location.state.start_date.replace(" ", "T")),
                new Date(location.state.end_date.replace(" ", "T"))
            ]);
        }
    }, [location.state?.start_date, location.state?.end_date]);

    const [combineWith, setCombineWith] = useState("ongkir");
    const [usageLimitValue, setUsageLimitValue] = useState('')

    const combineOptions = [
        {
            key: "ongkir",
            text: "Only with Ongkir",
            value: "ongkir",
        },
        {
            key: "any",
            text: "With Any Available Voucher",
            value: "any",
        },
    ];

    const handleSetTipe = (e) => {
        setTipe(e.value)
        setPercent(0)
        setValue(0)
    }
    
    return (
        <Container fluid>
            <Row className="mt-1 mb-3">
                <div className="text-facebook h3 mb-0">Edit Voucher</div>
                <div className="text-muted">Edit new voucher</div>
            </Row>
            <Divider />
            <Row className="d-flex justify-content-center mb-3 mt-3">
                <Col xl={6} lg={8} md={12} sm={12}>
                    <Form widths="equal" onSubmit={handleSubmit}>
                        
                        {/* Voucher Code & Name */}
                        <Form.Group widths="equal" className="mb-3">
                            <Form.Input
                                type="text"
                                label="Voucher Code"
                                value={code}
                                //error={submitted && !code}
                                onChange={(e, { value }) => setCode(value)}
                            />

                            <Form.Input
                                type="text"
                                label="Voucher Name"
                                value={name}
                                onChange={(e, { value }) => setName(value)}
                            />
                        </Form.Group>

                        {/* Voucher Description */}
                        <Form.Field className="mb-3">
                            <Form.Input
                                type="text"
                                label="Voucher Description"
                                value={desc}
                                error={submitted && !desc}
                                onChange={(e, { value }) => setDesc(value)}
                            />
                        </Form.Field>

                        {/* Allocation & Type */}
                        <Form.Group widths="equal" className="mb-3">
                            <Form.Select
                                label="Allocation"
                                options={alocation}
                                value={aloc}
                                error={submitted && !aloc}
                                onChange={(e, { value }) => setAloc(value)}
                            />

                            <Form.Select
                                label="Type"
                                options={type}
                                value={tipe}
                                error={submitted && !tipe}
                                //onChange={(e, { value }) => setTipe(value)}
                                onChange={(e, value) => handleSetTipe(value)}
                            />
                        </Form.Group>

                        {/* Voucher Value */}
                        <Form.Group widths="equal" className="mb-3">

                            {/* Percent */}
                            {(tipe === "D" || tipe === "O") && (
                                <Form.Input
                                    type="number"
                                    label="Voucher Percent"
                                    min={0}
                                    value={percent}
                                    disabled={tipe === "O" && Number(value) > 0}
                                    onChange={(e, { value }) => setPercent(value)}
                                />
                            )}

                            {/* Nominal */}
                            {(tipe === "N" || tipe === "O") && (
                                <Form.Input
                                    type="number"
                                    label="Voucher Nominal"
                                    min={0}
                                    value={value}
                                    disabled={tipe === "O" && Number(percent) > 0}
                                    onChange={(e, { value }) => setValue(value)}
                                />
                            )}

                        </Form.Group>

                        {/* Minimum Transaction & Minimum Order Qty */}
                        <Form.Group widths="equal" className="mb-3">
                            <Form.Input
                                type="number"
                                label="Minimum Transaction"
                                value={trx}
                                onChange={(e, { value }) => setTrx(value)}
                            />

                            <Form.Input
                                min={1}
                                max={10}
                                type="number"
                                label="Minimum Order Qty"
                                value={minQty}
                                onChange={(e, { value }) => setMinQty(value)}
                            />
                        </Form.Group>

                        {/* Voucher Options */}
                        <Form.Field className="mb-4">
                            <Form.Checkbox
                                label="Expose"
                                checked={expose === "Y"}
                                onChange={(e, data) => handleCheckExpose(data)}
                            />

                            <Form.Group
                                widths="equal" 
                            >
                                <Form.Field>
                                    <Form.Checkbox
                                        label="Combinable"
                                        checked={combine === "Y"}
                                        onChange={(e, data) => handleCheckCombine(data)}
                                    />
                                </Form.Field>

                                {combine === "Y" && (
                                    <Form.Field>
                                        <Form.Select
                                            options={combineOptions}
                                            value={combineWith}
                                            onChange={(e, { value }) => setCombineWith(value)}
                                        />
                                    </Form.Field>
                                )}
                            </Form.Group>

                            <Form.Group
                                widths="equal" 
                            >
                                <Form.Field>
                                    <Form.Checkbox
                                        label="Set Usage Limit"
                                        checked={usageLimit === "Y"}
                                        onChange={(e, data) => handleUsageLimit(data)}
                                    />
                                </Form.Field>

                                {usageLimit === "Y" && (
                                    <Form.Input
                                        type="number"
                                        placeholder="Set maximum usage limit e.g. 100"
                                        value={usageLimitValue}
                                        onChange={(e, { value }) => setUsageLimitValue(value)}
                                    />
                                )}
                            </Form.Group>
                        </Form.Field>

                        {/* Active Date */}
                        <Form.Field className="mb-3">
                            <label>Active Date</label>

                            <DateRangePicker
                                value={date}
                                format="yyyy-MM-dd HH:mm:ss"
                                appearance="default"
                                size="lg"
                                style={{ width: "100%" }}
                                placement="topStart"
                                onOk={setDate}
                                onChange={setDate}
                            />
                        </Form.Field>


                        <Form.Field className="mb-3 mt-5">
                            <Form.Button content="Update Voucher" color="facebook" />
                        </Form.Field>
                    </Form>
                </Col>
            </Row>
        </Container>

    )
}

export default VoucherEdit